(() => {
  'use strict';
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-load-map]');
    if (!trigger) return;
    const container = trigger.closest('[data-dedalaw-map]');
    if (!container || container.dataset.loaded === 'true') return;
    container.dataset.loaded = 'true';
    const frame = document.createElement('iframe');
    frame.title = 'dedalaw mailing and authorized-return address in Upland, California';
    frame.src = 'https://www.google.com/maps?q=1537%20WEDGEWOOD%20WAY%2C%20UPLAND%2C%20CA%2091786-2141&output=embed';
    frame.referrerPolicy = 'no-referrer-when-downgrade';
    frame.setAttribute('allowfullscreen', '');
    frame.setAttribute('tabindex', '0');
    container.replaceChildren(frame);
    frame.focus();
  });
})();
